"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.debounce = void 0;

/**
 * Run function after `wait` milliseconds have elapsed since last call
 *
 * @name       debounce
 * @tag        Core
 * @signature  (fn: Function, { wait: number, bind: Object }): Function
 *
 * @param  {Function}  fn                 Source function
 * @param  {Object}    [props]            Properties
 * @param  {number}    [props.wait=50]    Time in milliseconds to wait without
 *                                        calling until invoke
 * @param  {Object}    [props.bind=null]  `this` provided for the call to `fn`
 *
 * @returns  {Function}  Wrapper function that calls `fn` after `wait`
 *                       passed without calling
 *
 * @example
 * const debouncedAutocomplete = debounce(autocompleteFromAPI, {
 *   wait: 100,
 *   bind: this
 * })
 *
 * // render
 * <input onChange={debouncedAutocomplete} ... />
 */
var debounce = function debounce(fn) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$wait = _ref.wait,
      wait = _ref$wait === void 0 ? 50 : _ref$wait,
      _ref$bind = _ref.bind,
      bind = _ref$bind === void 0 ? null : _ref$bind;

  var finalRunTimer;
  return function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    // reset timer at every function call
    clearTimeout(finalRunTimer);
    finalRunTimer = setTimeout(function () {
      fn.apply(bind, args);
    }, wait);
  };
};

exports.debounce = debounce;